import store from '../index';
import { sendPost } from '../../utils/request';
import * as type from '../constants/ActionTypes';

// 获取union码
export const getUNIONCodeRequest = (data) => (
  sendPost('/trade/showOrder/getUnion', data).then((res) => {
    if (res && res.code === type.OK && res.body) {
      store.dispatch({ payload: res.body, type: type.UNION_CODE });
    }
    return res;
  })
);

export const getNewUnionConfig = (data) => {
  const url = '/backend/getUnionConf';
  return sendPost(url, data, false, true);
};

export const findByUnion = (data) => {
  const url = '/mallUnion/unionConfig/findByUnion';
  return sendPost(url, data);
};

export const findUnionBuoy = (data) => {
  const url = '/shopext/unionBuoy/findUnionBuoy';
  return sendPost(url, data);
};

